/**
 * Wholesale Register — everything in fieldOne
 * - Uses a real <form class="wh-register-form"> in your section
 * - Posts JSON with X-Api-Key and CORS (as enabled in your Flow webhook)
 */

(function () {
  // Hardcoded Flow webhook & token
  const WEBHOOK_URL = 'https://flow-webhooks.k8s.eu.codecreationlabs.cloud/webhook/s1twjjrk';
  const API_KEY     = '0d185v4e3p432g4s1u4r394q4c316i107l4216155q326f4m2l6u695o7n693p1s';

  const emailOk = v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || '').trim());
  const numOk   = v => v !== '' && Number.isFinite(Number(v)) && Number(v) >= 0;
  const setMsg  = (el, t, ok=false) => { if (!el) return; el.textContent = t || ''; el.style.color = ok ? 'inherit' : '#b91c1c'; };

document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-wh-reg-root]');
  if (!root) return;

  if (root.querySelector('[data-wh-success]')) return;

  const form  = root.querySelector('form.wh-register-form');
  const msgEl = root.querySelector('[data-msg]');
  if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      setMsg(msgEl, '');

      // Collect via FormData
      const d = {};
      new FormData(form).forEach((val, key) => { d[key] = (typeof val === 'string') ? val.trim() : val; });

      // Basic validation
      if (d.company_website)        return setMsg(msgEl, 'Submission blocked (bot detected).');
      if (!d.business_name)         return setMsg(msgEl, 'Please enter a business name.');
      if (!d.tax_number)            return setMsg(msgEl, 'Please enter a tax/ABN number.');
      if (!d.manager_name)          return setMsg(msgEl, 'Please enter a manager/owner name.');
      if (!emailOk(d.email))        return setMsg(msgEl, 'Please enter a valid email.');
      if (!d.phone)                 return setMsg(msgEl, 'Please enter a phone number.');
      if (!d.location)              return setMsg(msgEl, 'Please enter a store location.');
      if (!numOk(d.employees))      return setMsg(msgEl, 'Employees must be a number.');
      if (!d.storefront)            return setMsg(msgEl, 'Please select storefront yes/no.');
      if ('agree' in d && !d.agree) return setMsg(msgEl, 'Please agree to proceed.');

      // Helpful context for Flow (still inside fieldOne)
      d._shop         = window.Shopify?.shop || window.location.hostname;
      d._page         = window.location.href;
      d.submitted_at  = new Date().toISOString();

      // Everything in fieldOne only
      const payload = { fieldOne: d };

      const btn = form.querySelector('[data-send]') || form.querySelector('[type="submit"]');
      const original = btn?.textContent;
      if (btn) { btn.disabled = true; btn.textContent = 'Submitting…'; }

      try {
        const res = await fetch(WEBHOOK_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Api-Key': API_KEY
          },
          body: JSON.stringify(payload),
          mode: 'cors',
          redirect: 'manual',
          credentials: 'omit',
          cache: 'no-store'
        });

        const text = await res.text().catch(()=>'');
        if (res.ok) {
          form.outerHTML = '<div class="wh-success" style="padding:1rem;font-size:1rem;color:#333;">Thanks! We’ll be in touch shortly.</div>';
        } else {
          setMsg(msgEl, text || res.statusText || 'Error submitting the form.');
          if (btn) { btn.disabled = false; btn.textContent = original; }
        }
      } catch (err) {
        setMsg(msgEl, 'Network/CORS error — the webhook blocked the browser request.');
        if (btn) { btn.disabled = false; btn.textContent = original; }
      }
    });
  });
})();
